import { render } from "./TextareaAutosize.vue?vue&type=template&id=2d84c7c6"
import script from "./TextareaAutosize.vue?vue&type=script&lang=js"
export * from "./TextareaAutosize.vue?vue&type=script&lang=js"

import exportComponent from "/home/runner/work/TimeTracker_1.0/TimeTracker_1.0/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__